import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0da8431e"
import script from "./_footer.js?vue&type=script&lang=js&external"
export * from "./_footer.js?vue&type=script&lang=js&external"
import style0 from "./_footer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports